// import { configureStore } from '@reduxjs/toolkit'
// import addToCartReducer from './reducers/addToCartReducer';
// export default configureStore({
//   reducer: {
//     addToCart: addToCartReducer,
//   },
// })
import { createStore, combineReducers } from "redux";
import { addToCartReducer } from "./reducers/addToCartReducer";
const rootReducer = combineReducers({ addToCartReducer });
const store = createStore(rootReducer);

export default store;